// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Q4-z","colorTextValue":"R4-z","swatches":"S4-z","collapseLink":"T4-z","isCollapsed":"U4-z","dropdown":"V4-z","disabled":"W4-z"};